import { render, staticRenderFns } from "./SearchCommon.vue?vue&type=template&id=58020d4c&scoped=true&"
import script from "./SearchCommon.vue?vue&type=script&lang=js&"
export * from "./SearchCommon.vue?vue&type=script&lang=js&"
import style0 from "./SearchCommon.vue?vue&type=style&index=0&id=58020d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58020d4c",
  null
  
)

export default component.exports